import { datadogLogs } from '@datadog/browser-logs';
import { initBrowserRum } from '@smg-real-estate/browser-rum';

export const initDataDog: () => void = () => {
  const datadogClientToken = import.meta.env.VUE_DATADOG_PUBLIC_CLIENT_TOKEN;
  const datadogRumClientToken = import.meta.env.VUE_DATADOG_RUM_PUBLIC_CLIENT_TOKEN;
  const datadogRumApplicationId = import.meta.env.VUE_DATADOG_RUM_APPLICATION_ID;

  if (datadogClientToken) {
    datadogLogs.init({
      clientToken: datadogClientToken,
      service: import.meta.env.VUE_APP_PLATFORM + '-pdp-vue',
      env: import.meta.env.VUE_STAGE,
      site: 'datadoghq.eu',
      forwardErrorsToLogs: false,
      sessionSampleRate: 10,
    });
  }

  initBrowserRum({
    applicationId: datadogRumApplicationId,
    clientToken: datadogRumClientToken,
    service: import.meta.env.VUE_APP_PLATFORM + '-pdp-vue',
    env: import.meta.env.VUE_STAGE,
    sessionSampleRate: 1, // 1%
    sessionReplaySampleRate: 0, // no user session recordings
    version: import.meta.env.VUE_COMMIT_SHA,
  });
};
